import * as _4 from 'lodash4';

export class APMmTemplateSlot {
  id: number;
  slotDesc: string;
  slotType: string;
  instructions: string | null;
  courses: any[];
  courseGroupId: number;

  constructor(slot: Partial<APMmTemplateSlot>) {
    _4.merge(this, slot);
  }
  static build(slot: Partial<APMmTemplateSlot>): APMmTemplateSlot {
    return new APMmTemplateSlot(slot);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/builders/ap_multi_template_slot_builder.ts